<template>
  <div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="590px" class="custom_dialog" @close="closeDialog">
      <div class="content">
        <div class="tip-text">
          <p>您的账户尚未绑定手机号</p>
          <p class="line-two">绑定后可享受更加便捷的登陆方式~</p>
        </div>

      </div>
      <div>
        <el-button type="primary" style="margin-top: 16px;width:160px;" @click="toBind">前往绑定</el-button>
      </div>
      <div slot="footer" class="dialog-footer">
        <div class="operate-mian">
          <p @click="noShowTip">不再提示</p>
          <p @click="lastTalk">下次再说</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
  
  <script>
let resloveFun = (data) => { }
let rejectFun = (data) => { }
export default {
  name: 'UnboundPhone',
  data() {
    return {
      dialogVisible: false,
    }
  },
  methods: {
    showDialog() {
      return new Promise((resolve, reject) => {
        resloveFun = (data) => resolve(data)
        rejectFun = (data) => reject(data)
        this.dialogVisible = true
      })
    },
    toBind() {
      this.dialogVisible = false
      resloveFun({ type: 'toBind' })
    },
    noShowTip() {
      this.dialogVisible = false
      resloveFun({ type: 'noTip' })
    },
    lastTalk() {
      this.dialogVisible = false
      resloveFun({ type: 'lastTalk' })
    },
    closeDialog() {
      rejectFun('close')
    }
  }
}
  </script>
  
  <style lang="scss" scoped>
.content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.dialog-footer {
  display: flex;
  justify-content: center;
  .operate-mian {
    width: Translate(220px);
    display: flex;
    justify-content: space-between;
    font-size: Translate(14px);
    color: #999999;
    cursor: pointer;
  }
}
::v-deep .custom_my_form {
  .el-form-item {
    .el-form-item__label {
      color: #333333;
      padding: 0 15px 0 0;
    }
  }
}
.tip-text {
  font-size: Translate(16px);
  color: #333333;
  .line-two {
    margin-top: Translate(12px);
  }
}
</style>